<template>
    <div class="bg-grey vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backtobayar" v-if="this.dataidkasbon.islunas===0">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--left" @click="backtodetail" v-else>
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Riwayat Cicilan Kasbon</div>
                <div class="header-top--right">
                    <div class="header-item">
                    </div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page">
            <div class="p-x-20 p-y-16 w-limit">
                <div class="f-16 f-c-midgrey f-semi">Total Kasbon: Rp {{nominal_riwayat}}</div>
                <div class="m-t-16">

                    <div class="cicilan-item-timeline" v-for="riwayatx in riwayat_kasbon_riwayat" :key="riwayatx.id">
                        <div class="vert-line"></div>
                        <div class="card-item">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="f-16">Rp {{riwayatx.nominal}}</div>
                                <div class="f-12 f-regular f-c-muted">{{riwayatx.waktu_pembayaran}}</div>
                            </div>
                            <div class="m-t-4 f-12 f-c-midgrey" v-if="riwayatx.saldo>0">Sisa {{riwayatx.saldo}}</div>
                            <div class="m-t-4 f-12 f-c-midgrey cicilan-lunas" v-else>Terbayar lunas</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name:'RiwayatCicilKasbon',
        props:['dataidkasbon'],
        data(){
            return{
                nominal_riwayat:'',
                saldo_riwayat:'',
                waktu_bayar_riwayat:'',
                idkaryawan_riwayat:'',
                idkasbon_riwayat:'',
                riwayat_kasbon_riwayat:[],
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted() {
            this.getRiwayatkasbon()

            if (this.dataidkasbon.islunas===0) {
                this.backButtonPressed(this.backtobayar)
            } else {
                this.backButtonPressed(this.backtodetail)
            }
        },
        methods:{
            backtodetail(){
                this.$emit('backtodetailkasbon',{idkaryawan: this.dataidkasbon.idkaryawankasbon,idkasbon: this.dataidkasbon.idkasbon, islunas: 0, })
            },
            backtobayar(){
                this.$emit('showbayarkasbon',{idkaryawan: this.dataidkasbon.idkaryawankasbon,idkasbon: this.dataidkasbon.idkasbon, islunas: 0})
            },

            // <-- Fungsi Formatrupiah nominal riwayat bayar kasbon (cicil)-->

            inputnominalriwayatBayarkasbonLunas(){
                var handlecicil = this.nominal_riwayat;
                var hasilcicil = handlecicil.replace(/[^0-9]+/,'');
                this.nominal_riwayat=hasilcicil;
                this.formatrupiahnominalRiwayatkasbonLunas();
            },

            formatrupiahnominalRiwayatkasbonLunas(){
                var rupiahcicil = this.nominal_riwayat;
                var formattedrupiahcicil = this.newrupiahnominalRiwayatkasbonLunas(rupiahcicil);
                this.nominal_riwayat=formattedrupiahcicil;
            },

            newrupiahnominalRiwayatkasbonLunas(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            // <-- Fungsi Formatrupiah nominal riwayat bayar kasbon array (cicil)-->

            inputnominalriwayatBayarkasbonLunasn(){
                var handlecicil = this.nominal_riwayat;
                var hasilcicil = handlecicil.replace(/[^0-9]+/,'');
                this.nominal_riwayat=hasilcicil;
                this.formatrupiahnominalRiwayatkasbonLunasn();
            },

            formatrupiahnominalRiwayatkasbonLunasn(){
                var rupiahcicil = this.nominal_riwayat;
                var formattedrupiahcicil = this.newrupiahnominalRiwayatkasbonLunasn(rupiahcicil);
                this.nominal_riwayat=formattedrupiahcicil;
            },

            newrupiahnominalRiwayatkasbonLunasn(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            // <-- Fungsi Formatrupiah nominal riwayat bayar kasbon array (cicil)-->

            // inputnominalriwayatBayarkasbonLunasn(){
            //     var handlecicil = this.nominal_riwayat;
            //     var hasilcicil = handlecicil.replace(/[^0-9]+/,'');
            //     this.nominal_riwayat=hasilcicil;
            //     this.formatrupiahnominalRiwayatkasbonLunasn();
            // },
			//
            // formatrupiahnominalRiwayatkasbonLunasn(){
            //     var rupiahcicil = this.nominal_riwayat;
            //     var formattedrupiahcicil = this.newrupiahnominalRiwayatkasbonLunasn(rupiahcicil);
            //     this.nominal_riwayat=formattedrupiahcicil;
            // },
			//
            // newrupiahnominalRiwayatkasbonLunasn(angka, prefix){
            //     /* Fungsi formatRupiah */
            //     var number_string = angka.replace(/[^,\d]/g, "").toString(),
            //         split = number_string.split(","),
            //         sisa = split[0].length % 3,
            //         rupiah = split[0].substr(0, sisa),
            //         ribuan = split[0].substr(sisa).match(/\d{3}/gi);
            //     // tambahkan titik jika yang di input sudah menjadi angka ribuan
            //     if (ribuan) {
            //         var separator = sisa ? "." : "";
            //         rupiah += separator + ribuan.join(".");
            //     }
			//
            //     rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
            //     return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            // },

            // <-- Get Fungsi Detail Riwayat-->

            async getRiwayatkasbon() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_karyawan_kasbon?idkasbon=' + this.dataidkasbon.idkasbon + '&idkaryawan=' + this.dataidkasbon.idkaryawankasbon,this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.inputnominalriwayatBayarkasbonLunas();
                            this.inputnominalriwayatBayarkasbonLunasn()
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide();
                            var riwayatkasbon = response.data.data.detail.kasbon_bayar;
                            var datariwayat = response.data.data;
                            this.waktu_bayar_riwayat = datariwayat.waktu_pembayaran_terakhir;
                            var nominal_riwayat = response.data.data.detail.nominal;
                            var toRp = this.newrupiahnominalRiwayatkasbonLunas(nominal_riwayat.toString());
                            this.nominal_riwayat = toRp;
                            for (var i = riwayatkasbon.length; i > 0; i--) {
                                var nominal_riwayat_array = riwayatkasbon[i-1].nominal
                                var toRparray = this.newrupiahnominalRiwayatkasbonLunas(nominal_riwayat_array.toString());
                                var saldo_riwayat_array = riwayatkasbon[i-1].sisa_saldo;
                                var toRparraysaldo = this.newrupiahnominalRiwayatkasbonLunas(saldo_riwayat_array.toString());
                                this.riwayat_kasbon_riwayat.push({
                                    nama:riwayatkasbon[i-1].NamaKaryawan,
                                    id:riwayatkasbon[i-1].Id,
                                    keterangan:riwayatkasbon[i-1].Keterangan,
                                    saldo:toRparraysaldo,
                                    nominal:toRparray,
                                    waktu:riwayatkasbon[i-1].WaktuPotongan,
                                    tanggal_lunas:riwayatkasbon[i-1].WaktuPembayaranTerakhir,
	                                waktu_pembayaran: riwayatkasbon[i-1].waktu_pembayaran.replace("T", " ").replace("+07:00", "")
                                })
                            }

                        }
                    }

                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },
        }
    }
</script>

<style>
.cicilan-item-timeline {
    position: relative;
    display: flex;
}

.cicilan-item-timeline .card-item {
    flex-grow: 1;
    margin-left: 16px;
}

.cicilan-item-timeline:not(:last-child) .card-item {
    margin-bottom: 12px;
}

.cicilan-item-timeline .vert-line {
    width: 2px;
    height: 100%;
    background: #C8D0DD;
    position: absolute;
}

.cicilan-item-timeline .vert-line:before{
    content: '';
    position: absolute;
    left: -6px;
    top: 0;
    width: 14px;
    height: 14px;
    background: #C8D0DD;
    border-radius: 50%;
    border: 4px solid #F2F5F7;
}

.cicilan-item-timeline:first-child .vert-line:before {
    background: #206CFF;
}

.cicilan-item-timeline:last-child .vert-line {
    width: 0px;
}

</style>